@use "styles" as *;

.me-if {
  display: block;

  &__if-branch, &__else-branch {
    display: inherit;
  }

  &:not(&--satisfied) &__if-branch {
    display: none;
  }

  &--satisfied &__else-branch {
    display: none;
  }
}
